import React, { Component } from 'react';
import Navbar from '../components/Navbar/Navigation';
import Footer from '../components/Footer/Footer';
import Contact from '../components/Forms/Contact';
import Map from '../components/Panel/Map';

import './Kontakt.css';

class Kontakt extends Component {
  render() {
    return (
      <div>
        <Navbar />
        <div>
          <Contact />
          <Map />
          <Footer />
        </div>
      </div>
    );
  }
}

export default Kontakt;
